import { PayloadAction, AnyAction } from "@reduxjs/toolkit";
import { ReduxHelper } from "helpers";
import {
  IBaseReducerActionState,
  IBaseReducerState,
} from "helpers/reduxHelpers";
import { IPaginateApiResponse, IPrepare, IPrepareDetail } from "model";
import { PrepareActions } from "redux/actions";

interface IPrepareState extends IBaseReducerState {
  prepare?: IPaginateApiResponse<IPrepare[]>;
  prepareDetail: IBaseReducerActionState<
    IPaginateApiResponse<IPrepareDetail[]>
  >;
}

const initialState: IPrepareState = {
  action: PrepareActions.prefix,
  prefix: PrepareActions.prefix,
  prepareDetail: {
    action: "PREPARE_DOCUMENT_DETAIL",
  },
};

const getAllPrepareDocumentsSuccess = (
  state: IPrepareState,
  action: PayloadAction<IPaginateApiResponse<IPrepare[]>>
) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.prepare = action.payload;
  });

const getPrepareDocumentDetailSuccess = (
  state: IPrepareState,
  action: PayloadAction<IPaginateApiResponse<IPrepareDetail[]>>
) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.prepareDetail.data = action.payload;
    state.prepareDetail.action = action.type;
  });

const PrepareReducer = ReduxHelper.createHandleReducer(
  initialState,
  (builder) => {
    builder
      .addCase(
        PrepareActions.getAllPrepareDocuments.success,
        getAllPrepareDocumentsSuccess
      )

      .addCase(
        PrepareActions.getPrepareDocumentDetail.success,
        getPrepareDocumentDetailSuccess
      );
  },
  (state: IPrepareState, action: AnyAction) => {
    const watcherAction = action.type;

    if (watcherAction?.includes("PREPARE_DOCUMENT_DETAIL")) {
      state.prepareDetail.action = action.type;
    }
  }
);

export default PrepareReducer;
